import {
  RESET_VUEX_SYSTEM_ROLES,
  GET_ALL_ROLES,
  GET_SPECIFIC_ROLE,
  SET_SELECTED_ROLES,
  GET_RAMAIS,
  SET_SELECTED_RAMAIS_RELATORIO_PABX,
  SET_SELECTED_RAMAIS_MONITOR_RAMAIS,
  GET_TAGS,
  SET_SELECTED_TAGS_RELATORIO_PABX,
  SET_SELECTED_TAGS_PESQUISA_SATISFACAO,
  GET_CONFERENCIAS,
  SET_SELECTED_CONFERENCIAS,
  GET_FILAS,
  GET_DEPARTAMENTOS,
  GET_OPERADORES,
  SET_SELECTED_FILAS,
  SET_SELECTED_DEPARTAMENTOS,
  SET_SELECTED_OPERADORES,
  GET_PESQUISAS_SATISFACAO,
  SET_SELECTED_PESQUISAS_SATISFACAO,
  ADD_PERMISSION_ID,
  DELETE_PERMISSION_ID,
  CHANGE_ALL_PERMISSION_ID,
} from "./mutation-types";

import perfisHttpService from "../_services/perfisHttpService";

export default {
  resetarConfiguracoesPerfil: async ({ commit }) => {
    commit(RESET_VUEX_SYSTEM_ROLES);
  },
  listAllRamais: async ({ commit }) => {
    try {
      const response = await perfisHttpService.getRamais();
      commit(GET_RAMAIS, response.data.ramais);
    } catch (e) {
      console.log(e.message);
    }
  },

  listAllTags: async ({ commit }) => {
    try {
      const response = await perfisHttpService.getTAGs();
      commit(GET_TAGS, response.data);
    } catch (e) {
      console.log(e.message);
    }
  },

  listAllConferencias: async ({ commit }) => {
    try {
      const response = await perfisHttpService.getConferencias();
      commit(GET_CONFERENCIAS, response.data);
    } catch (e) {
      console.log(e.message);
    }
  },

  listAllFilas: async ({ commit }) => {
    try {
      const response = await perfisHttpService.getQueues();
      commit(GET_FILAS, response.data);
    } catch (e) {
      console.log(e.message);
    }
  },

  listaAllDepartamentos: async({ commit }) =>{
    try{
      const response = await perfisHttpService.getDepartamentos();
      commit(GET_DEPARTAMENTOS, response.data);
    }catch(e){
      console.log(e.message)
    }
  },

  listAllOperadores: async ({ commit }) => {
    try {
      const response = await perfisHttpService.getAgents();
      commit(GET_OPERADORES, response.data);
    } catch (e) {
      console.log(e.message);
    }
  },

  listAllPesquisasSatisfacao: async ({ commit }) => {
    try {
      const response = await perfisHttpService.getPesquisasSatisfacao();
      commit(GET_PESQUISAS_SATISFACAO, response.data);
    } catch (e) {
      console.log(e.message);
    }
  },

  listAllRoles: async ({ commit }) => {
    try {
      const response = await perfisHttpService.getRoles();
      commit(GET_ALL_ROLES, response.data);
    } catch (e) {
      console.log(e.message);
    }
  },

  listSpecificRole: async ({ commit }, id) => {
    try {
      const response = await perfisHttpService.getRole(id);
      commit(GET_SPECIFIC_ROLE, response.data);
    } catch (e) {
      console.log(e.message);
    }
  },

  // =================

  addPermissionsID: async ({ commit }, permissionsId) => {
    try {
      commit(ADD_PERMISSION_ID, permissionsId);
    } catch (e) {
      console.log(e);
    }
  },
  deletePermissionsID: async ({ commit }, permissionsId) => {
    try {
      commit(DELETE_PERMISSION_ID, permissionsId);
    } catch (e) {
      console.log(e);
    }
  },
  changeAllPermissionsID: async ({ commit }, permissionsIds) => {
    try {
      commit(CHANGE_ALL_PERMISSION_ID, permissionsIds);
    } catch (e) {
      console.log(e);
    }
  },

  setSelectedFilas: async ({ commit }, arrayIdsFilas) => {
    try {
      commit(SET_SELECTED_FILAS, arrayIdsFilas);
    } catch (e) {
      console.log(e);
    }
  },

  setSelectedDepartamentos: async ({ commit }, arrayIdDepartamento) => {
    try {
      commit(SET_SELECTED_DEPARTAMENTOS, arrayIdDepartamento);
    } catch (e) {
      console.log(e);
    }
  },


  setSelectedOperadores: async ({ commit }, arrayIdsOperadores) => {
    try {
      commit(SET_SELECTED_OPERADORES, arrayIdsOperadores);
    } catch (e) {
      console.log(e);
    }
  },
  setSelectedRamaisRelatoriosPABX: async ({ commit }, idsRamaisArray) => {
    try {
      commit(SET_SELECTED_RAMAIS_RELATORIO_PABX, idsRamaisArray);
    } catch (e) {
      console.log(e);
    }
  },
  setSelectedTagsRelatoriosPABX: async ({ commit }, idsTagsArray) => {
    try {
      commit(SET_SELECTED_TAGS_RELATORIO_PABX, idsTagsArray);
    } catch (e) {
      console.log(e);
    }
  },
  setSelectedConferencias: async ({ commit }, arrayIdsConferencias) => {
    try {
      commit(SET_SELECTED_CONFERENCIAS, arrayIdsConferencias);
    } catch (e) {
      console.log(e);
    }
  },
  setSelectedRamaisMonitorRamais: async ({ commit }, idsRamaisArray) => {
    try {
      commit(SET_SELECTED_RAMAIS_MONITOR_RAMAIS, idsRamaisArray);
    } catch (e) {
      console.log(e);
    }
  },
  setSelectedPesquisasSatisfacao: async (
    { commit },
    arrayIdsPesquisasSatisfacao
  ) => {
    try {
      commit(SET_SELECTED_PESQUISAS_SATISFACAO, arrayIdsPesquisasSatisfacao);
    } catch (e) {
      console.log(e);
    }
  },
  setSelectedTagsPesquisaSatisfacao: async ({ commit }, idsTagsArray) => {
    try {
      commit(SET_SELECTED_TAGS_PESQUISA_SATISFACAO, idsTagsArray);
    } catch (e) {
      console.log(e);
    }
  },
  setSelectedRoles: async ({ commit }, selectedRoles) => {
    try {
      commit(SET_SELECTED_ROLES, selectedRoles);
    } catch (e) {
      console.log(e.message);
    }
  },
};
